/** Fired when a full-screen overlay (e.g. match share) opens — `MainNav` should close its drawer. */
export const CLOSE_PUBLIC_MOBILE_NAV_EVENT = 'ffl-close-public-mobile-nav';

export function dispatchClosePublicMobileNav(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CLOSE_PUBLIC_MOBILE_NAV_EVENT));
}
